'use client'

import React from 'react'
import { useAuth } from '../context/AuthContext'
import { appKitModal } from '../context'
import { useRouter } from 'next/navigation'

interface ProtectedRouteProps {
  children: React.ReactNode
  fallback?: React.ReactNode
  redirectTo?: string
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  fallback,
  redirectTo,
}) => {
  const { isAuthenticated, isLoading } = useAuth()
  const router = useRouter()

  // Handle loading state
  if (isLoading) {
    return <div className="auth-loading">Loading...</div>
  }

  // Handle unauthenticated state
  if (!isAuthenticated) {
    // If redirectTo is provided, redirect
    if (redirectTo) {
      router.push(redirectTo)
      return null
    }

    // If fallback is provided, show it
    if (fallback) {
      return <>{fallback}</>
    }

    // Default fallback is a connect wallet button
    return (
      <div className="auth-required">
        <h2>Authentication Required</h2>
        <p>You need to connect your wallet and verify your email to access this page.</p>
        <button
          className="connect-wallet-btn"
          onClick={() => appKitModal.open()}
        >
          Connect Wallet
        </button>
      </div>
    )
  }

  // Render children if authenticated
  return <>{children}</>
}

export default ProtectedRoute 